/* eslint-disable @typescript-eslint/no-unused-vars */
import { createModel } from '@wmfe/mach-pro-store';

export const filterBarHandleModel = createModel()({
  state: {
    filterBarPanelHandleParentViewRef: null,
    filterBarHandleLxModel: {},
    filterBarHandlePopupWillShowIntercept: undefined,
    filterBarHandlePanelItemDidSelectedIntercept: undefined,
    filterBarHandlePanelDataPayload: {},
  },

  reducers: {
  },

  effects: (dispatch) => ({

    didFilterBarDataSelectedChanged: (payload) => {
      const { options } = payload;
      // 刷新feed区数据
      dispatch.global.handleShowLoading(true);
      dispatch.global.fetchFeedListData({ pageNo: 0, options, refreshType: 1 });
    },

    didFilterBarPanelExpandedChanged: (payload) => {
      dispatch.global.updateFilterBarPanelInMainExpanded(payload);
    },

    updateFilterBarHandlePanelParentViewRef: (payload, { filterBarHandleModel }) => {
      const { ref } = payload;
      // @ts-ignore
      filterBarHandleModel.filterBarPanelHandleParentViewRef = ref;
      dispatch.filterBarModel?.updateFilterBarPanelParentViewRef?.(payload);
    },

    updateFilterBarHandleLxSourceModel: (payload, { filterBarHandleModel }) => {
      const { lxModel } = payload;
      // @ts-ignore
      filterBarHandleModel.filterBarHandleLxModel = lxModel;
      dispatch.filterBarModel?.updateFilterBarLxSourceModel?.(payload);
    },

    updateFilterBarHandlePanelData: (payload, { filterBarHandleModel }) => {
      // @ts-ignore
      filterBarHandleModel.filterBarHandlePanelDataPayload = payload;
      dispatch.filterBarModel?.updateFilterBarPanelData?.(payload);
    },

    updateBindFilterIntercepts: (payload, { filterBarHandleModel }) => {
      const { popupWillShowIntercept, panelItemDidSelectedIntercept } = payload;
      // @ts-ignore
      filterBarHandleModel.filterBarHandlePopupWillShowIntercept = popupWillShowIntercept;
      // @ts-ignore
      filterBarHandleModel.filterBarHandlePanelItemDidSelectedIntercept = panelItemDidSelectedIntercept;

      dispatch.filterBarModel?.bindFilterBarPopupWillShowIntercept?.({ intercept: popupWillShowIntercept });
      dispatch.filterBarModel?.bindFilterBarPanelItemDidSelectedIntercept?.({ intercept: panelItemDidSelectedIntercept });
    },

  })
});
